import { render, staticRenderFns } from "./JCron.vue?vue&type=template&id=04105b72&scoped=true&"
import script from "./JCron.vue?vue&type=script&lang=js&"
export * from "./JCron.vue?vue&type=script&lang=js&"
import style0 from "./JCron.vue?vue&type=style&index=0&id=04105b72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04105b72",
  null
  
)

export default component.exports